import Moment from 'moment';
import {
  VFL_COMPARATORS,
  VFL_COMPARATORS_FILTER_COMPARATOR_LOOKUP,
} from './velarisFilterLanguage';

export function formatDateFiltersToQueryParams(filter, value) {
  switch (filter) {
    case 'equals': {
      const startOfDay = Moment(value[0]).startOf('day').utc().toISOString();
      const endOfDay = Moment(value[0]).endOf('day').utc().toISOString();
      return [
        `on_or_after=${encodeURIComponent(startOfDay)}`,
        `on_or_before=${encodeURIComponent(endOfDay)}`,
      ];
    }
    case 'greater': {
      const after = Moment(value[0]).endOf('day').utc().toISOString();
      return [`after=${encodeURIComponent(after)}`];
    }
    case 'greaterEqual': {
      const onOrAfter = Moment(value[0]).startOf('day').utc().toISOString();
      return [`on_or_after=${encodeURIComponent(onOrAfter)}`];
    }
    case 'lesser': {
      const before = Moment(value[0]).startOf('day').utc().toISOString();
      return [`before=${encodeURIComponent(before)}`];
    }
    case 'lesserEqual': {
      const onOrBefore = Moment(value[0]).endOf('day').utc().toISOString();
      return [`on_or_before=${encodeURIComponent(onOrBefore)}`];
    }
    case 'between': {
      const rangeStart = Moment(value[0]).startOf('day').utc().toISOString();
      const rangeEnd = Moment(value[1]).endOf('day').utc().toISOString();
      return [
        `on_or_after=${encodeURIComponent(rangeStart)}`,
        `on_or_before=${encodeURIComponent(rangeEnd)}`,
      ];
    }
    default:
      return [];
  }
}

export function mapFiltersToQueryParams(filtersMap, attributeMap) {
  return Object.values(filtersMap).reduce((acc, filterData) => {
    const {
      attribute: { name: attribute },
      filter,
      value,
    } = filterData;

    if (attributeMap[attribute]) {
      const queryKey = attributeMap[attribute];
      if (
        filter ===
        VFL_COMPARATORS_FILTER_COMPARATOR_LOOKUP[VFL_COMPARATORS.isSet]
      ) {
        acc.push(`${queryKey}=isset`);
      }
      if (
        filter ===
        VFL_COMPARATORS_FILTER_COMPARATOR_LOOKUP[VFL_COMPARATORS.isNotSet]
      ) {
        acc.push(`${queryKey}=isnotset`);
      } else if (
        filter ===
        VFL_COMPARATORS_FILTER_COMPARATOR_LOOKUP[VFL_COMPARATORS.isSetTo]
      ) {
        acc.push(`${queryKey}=${encodeURIComponent(value)}`);
      } else if (attribute === 'date' || attribute === 'CreatedAt') {
        acc.push(...formatDateFiltersToQueryParams(filter, value));
      }
    }

    return acc;
  }, []);
}

export function getAdditionalFilterQueryParams(additionalFilters) {
  return additionalFilters.length > 0 ? `&${additionalFilters.join('&')}` : '';
}

export function mapEmailFiltersToQueryParams(filtersMap) {
  const attributeMap = {
    from: 'from',
    to: 'to',
    cc: 'cc',
    emailStatus: 'emailStatus',
    date: 'date',
  };
  return mapFiltersToQueryParams(filtersMap, attributeMap);
}

export function getAdditionalFilters(filters, mapperFunction) {
  const additionalFilters = [];

  if (filters) {
    const { subject, ...otherFilters } = filters;
    if (subject) {
      additionalFilters.push(`subject=${encodeURIComponent(subject)}`);
    }
    if (Object.keys(otherFilters).length > 0) {
      const messageFilters = mapperFunction(otherFilters);
      additionalFilters.push(...messageFilters);
    }
  }

  return getAdditionalFilterQueryParams(additionalFilters);
}
